import router, { getCurrentRoute } from './routerInstance';
import { resetLastProcessedRoute } from './lastProcessedRoute';
import getScopedPath from 'owa-url/lib/getScopedPath';
import { mergeQueryStrings } from 'owa-querystring';
import { trace } from 'owa-trace';

let isNavigatingFlag = false;
let forceRouteHandlerFlag = false;

export function isNavigating(): boolean {
    return isNavigatingFlag;
}

export function setForceRouteHandler(value: boolean): void {
    forceRouteHandlerFlag = value;
}

export function getForceRouteHandler(): boolean {
    return forceRouteHandlerFlag;
}

let vdirPrefix: string = '';
export function setVdir(vdir: string): void {
    vdirPrefix = getScopedPath(vdir).substr(1) + '/';
}

export function getVdir(): string {
    return vdirPrefix;
}

/*
    Navigates to a route, given its segments. The segments must NOT include the vdir.
    Optional queryParameters is a string that will be merged with the existing query string,
    where new query parameters will overwrite values of duplicate keys in the existing query string if any.
*/
export default function navigateToRoute(pathSegments: string[], queryParameters?: string): void {
    const encodedPath: string = vdirPrefix + pathSegments.map(fixedEncodeURIComponent).join('/');

    // Because of when director.js calls onChange for html5history, the navigation needs to:
    // 1. Prevent navigation during navigation
    // 2. Prevent navigation if the routes are the SAME due to autorun in keepRouteCurrent
    if (isNavigating() || getCurrentRoute().join('/') == encodedPath) {
        return;
    }

    // Append any incoming query parameters to existing query string; assumes appropriate encoding is already handled
    const queryString: string = mergeQueryStrings(location.search, queryParameters);

    isNavigatingFlag = true;

    try {
        const newRoute = '/' + encodedPath + queryString;
        trace.info(`Navigating to ${newRoute}`, 'router');
        router.setRoute(newRoute);
    } finally {
        isNavigatingFlag = false;
        forceRouteHandlerFlag = false;
    }

    resetLastProcessedRoute();
}

function fixedEncodeURIComponent(str: string) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
}
